import { CheckboxQuestionV2 } from './question-checkbox';
import { DatetimeQuestionV2 } from './question-datetime';
import { DescriptionQuestionV2 } from './question-description';
import { DropdownQuestionV2 } from './question-dropdown';
import { FieldsBlocQuestionV2 } from './question-fieldsBloc';
import { HiddenQuestionV2 } from './question-hidden';
import { ImageQuestionV2 } from './question-image';
import { MultiDropdownQuestionV2 } from './question-multiDropdown';
import { NestedGroupQuestionV2 } from './question-nestedGroup';
import { NumberRangeQuestionV2 } from './question-numberRange';
import { PhotoQuestionV2 } from './question-photo';
import { RadioQuestionV2 } from './question-radio';
import { RangeQuestionV2 } from './question-range';
import { SemanticQuestionV2 } from './question-semantic';
import { SocialSecurityQuestionV2 } from './question-social-security';
import { TextQuestionV2 } from './question-text';
import { TextAreaQuestionV2 } from './question-textarea';
import { ToggleQuestionV2 } from './question-toggle';
import { SignaturePadV2 } from './question-signature-pad';
import { VideoQuestionV2 } from './question-video';

export enum QuestionV2ControlTypes {
  CHECKBOX,
  DATETIME,
  DROPDOWN,
  DESCRIPTION,
  IMAGE,
  MULTI_DROPDOWN,
  NESTED_GROUP,
  NUMBER_RANGE,
  RADIO,
  RANGE,
  SEMANTIC,
  SOCIAL_SECURITY,
  TEXT,
  TEXTAREA,
  TOGGLE,
  EQ5,
  HTML,
  PHOTO,
  FIELDS_BLOC,
  FILE,
  HIDDEN,
  SIGNATURE_PAD,
  VIDEO
}

export enum ConstraintTypes {
  REQUIRED = 'required',
  RANGE = 'range',
  MAXLENGTH = 'maxLen',
  LENGTH = 'len',
  EMAIL = 'email',
  MIN = 'min',
  MAX = 'max',
  PATTERN = 'pattern',
  LIMIT_CONDITION = 'limitCondition',
  MAXSIZE = 'maxSize'
}

export type QuestionsV2 =
  | CheckboxQuestionV2
  | DatetimeQuestionV2
  | DropdownQuestionV2
  | DescriptionQuestionV2
  | ImageQuestionV2
  | MultiDropdownQuestionV2
  | NestedGroupQuestionV2
  | NumberRangeQuestionV2
  | RadioQuestionV2
  | RangeQuestionV2
  | SemanticQuestionV2
  | SocialSecurityQuestionV2
  | TextQuestionV2
  | TextAreaQuestionV2
  | ToggleQuestionV2
  | PhotoQuestionV2
  | FieldsBlocQuestionV2
  | HiddenQuestionV2
  | SignaturePadV2
  | VideoQuestionV2;

export enum NumericComparison {
  eq,
  neq,
  lt,
  lte,
  gt,
  gte
}

export enum SupportedVideoType {
  YOUTUBE = 'youtube',
  VIMEO = 'vimeo'
}
